function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#add_booking_svg__clip0)",
  fill: "current"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.89 8.78L7 15.34v8.56l10.89-6.56V8.78zM16.83 3.14H13.7V0h-2.51v3.14H8.06v2.5h3.13v3.14h2.51V5.64h3.13v-2.5z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "add_booking_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(7)",
  d: "M0 0h10.89v23.89H0z"
})));

function SvgAddBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgAddBooking;